module.exports = __webpack_public_path__ + "static/media/5.14_preview.1a636f67.png";